/**
 * Created by sxp23 on 1/16/2018.
 */
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { forkJoin, Subscription }   from 'rxjs';
import { Router} from '@angular/router';

/*import { TreeNode} from 'primeng/primeng'*/
import * as FileSaver from 'file-saver';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

import { CommonService } from '../common.service';
import { SharedService } from '../shared.service'
import {forEach} from "@angular/router/src/utils/collection";

@Component({
  selector: 'water-systems',
  templateUrl: './water-systems.component.html',
  styleUrls: ['./water-systems.component.css']
})
export class WaterSystemsComponent implements OnInit, OnDestroy, AfterViewInit {

  selectedWaterSystem: [any];

  subscription: Subscription;

  //files: TreeNode[];

  showContaminants = true;
  showViolations = false;
  showReportPdf = false;
  showContactInfo = false;
  innerWidth = 0;
  userLat = 42.652580;
  userLng = -73.756233;

  cols: any[];

  pwsId:string;
  location;
  pwsName;pwsCounty;
  pwsPopulation:any;
  mobile;iPad;
  //violationsCount:number=0;contaminantsCount:number=0;
  annualReportList;
  noAnnualReportMsg;
  //msgs: Message[] = [];

  @ViewChild('contentSelPWS2') contentPWS: ElementRef;

  constructor(private commonService: CommonService, private sharedService:SharedService, private router:Router, private modalService:NgbModal) {
    this.subscription = sharedService.pwsId$.subscribe(
      pwsId => {
        //this.pwsId = pwsId;
        //console.log('pwsId in WaterSystemsComponent CONSTR::', pwsId);
        if (pwsId) {
          this.pwsId = pwsId;
          /*var pwsObj = JSON.parse(pwsId);
          this.pwsId = pwsObj.pwsId;
          this.pwsName = pwsObj.pwsName;
          this.pwsCounty = pwsObj.county;
          console.log("pwsId$ in Water system", pwsId);*/
          //this.violationsCount=0;
          //this.contaminantsCount=0;
          //if (this.sharedService.getPwsId()!==pwsId && (!this.annualReportList||this.annualReportList.length===0)) {
            this.getSelectedPWS(this.pwsId);
         //}
        }
      });
    //console.log("this.subscription", this.subscription);
  }
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(()=> {
      this.modalService.open(this.contentPWS, { size: 'lg', windowClass: 'modal-adaptive' });
    }, 200);
  }

  ngOnInit() {
    //get all PWS AWQ Report metadata
    if (!this.annualReportList||this.annualReportList.length===0) {
      /*var maxYear = (new Date()).getFullYear();
      var superSet = [];
      this.allMetaData= [];
      for (var i=2016; i<=maxYear; i++) {   console.log("i==============="+i);
        superSet.push(i);
      }
      let observables = superSet.map(year =>  this.commonService.getAnnualRepMetaDataByYr(year));
      // forkJoin the array/collection of observables
      let source = forkJoin(observables);
      source.subscribe(
        metaData => { console.log("######", this.allMetaData, metaData, superSet);
          metaData.forEach((arr)=>{ console.log("$$$$$$", arr)
            if (arr){ console.log(44444444444444)
              this.allMetaData = this.allMetaData.concat(arr);
            }
          });
        },
        err => console.error("Error in getAnnualRepMetaDataByYr() call::", err),
        () => {
          if (this.sharedService.getPwsId()) {
           this.pwsId = this.sharedService.getPwsId();
           //this.violationsCount=0;
           //this.contaminantsCount=0;
           this.getSelectedPWS(this.pwsId);
           }
        }
      );*/

     /* if (this.sharedService.getPwsId()) {
        this.pwsId = this.sharedService.getPwsId();
        //this.violationsCount=0;
        //this.contaminantsCount=0;
        this.getSelectedPWS(this.pwsId);
      }*/

      if (window.screen.width < 768) { // 768px portrait
        this.mobile = true;
      }
      else if (window.screen.width < 1000) {
        this.iPad = true
      }
      //this.sharedService.setFlowFlag("DOH");
    }
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'modal-adaptive' });
  }
 selectedPWS = {"pwsName":null,"pwsId":null,"principalCountyServedName":null,"wsysId":null,"latitude":null,"longitude":null,"systemPopulation":null};

  pwsList;
  wsId;
  //private getSelectedPWS(wsysId:number):any{
  private getSelectedPWS(pwsId:string):any{
      this.commonService.getDOHMapPWSByPwsID(pwsId, 25).subscribe(
      pwsList => {
        //console.log("pwsList", pwsList);
        if (pwsList) {
          this.pwsPopulation = pwsList[0].systemPopulation;
          this.pwsName = pwsList[0].pwsName;
          this.pwsCounty = pwsList[0].principalCountyServedName;
          this.selectedPWS = pwsList[0];
          this.wsId = pwsList[0].wsysId;
          this.pwsList = pwsList;
          this.getAnnualReport(this.selectedPWS.pwsId, this.selectedPWS.pwsName);
        }
        else{
          console.log("ERROR: Unable to find details for PWS ID:"+pwsId);
          //this.msgs.push({ severity: 'error', summary: 'Error :', detail: 'Unable to find details for PWS ID:'+pwsId });
        }
        this.cols = [
          {field: 'pwsName', header: 'PWS Name'},
          {field: 'pwsId', header: 'PWS ID'},
          {field: 'principalCountyServedName', header: 'County Served'},
          {field: 'systemPopulation', header: 'Population Served'}
        ];
      },
      err => console.error("Error in getSelectedPWS() call::", err),
      () => {
        //this.getContaminants(this.wsId);
        //this.getViolations(this.wsId);
        if (this.wsId){
          this.getDOHContacts(this.wsId);
        }
      }
    );
  }


  private getAnnualReport(pwsId:string, pwsName:string):any{
    this.annualReportList = [];
    var annualRep = {"awrId":null,"annualReportName":null,"awrMimeType":null,"yr":null};
    this.noAnnualReportMsg="Please wait..";
    var repName,repId,mimeType, cnt=0;
    var localThis=this;

    this.commonService.getAnnualRepMetaData(pwsId).subscribe(
      metaData => {
        //console.log("AWR metaData", metaData);
        if (pwsName)
          pwsName = pwsName.replace(/\w\S*!/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase())); // + " :";
        else
          pwsName = "";
        if (metaData) {
          metaData.forEach((arr)=> {
            if (arr) {
              annualRep = {"awrId": null, "annualReportName": null, "awrMimeType": null,"yr":null};
              if (arr.year && parseInt(arr.year) > 2015) {
                //console.log("arr==", arr)
                repName = pwsName + " : Annual Water Quality Report " + arr.year; //+"("+arr.fileName+")";
                annualRep.annualReportName = repName;
                annualRep.awrId = arr.id;
                annualRep.awrMimeType = arr.mimeType;
                annualRep.yr = parseInt(arr.year);
                localThis.annualReportList.push(annualRep);
              }
            }
          });
        }
      },
      err => console.error("Error in getAnnualRepMetaData() call::", err),
      () => {
        if (!this.annualReportList || this.annualReportList.length===0) {
          this.noAnnualReportMsg = "Sorry, The Annual Drinking Water Quality Report is not available for "+pwsName;
        }
        else{
          var newList = this.annualReportList.sort(function(a, b){ return b.yr - a.yr});
          this.annualReportList = newList;
        }
      }
    );




    /*if (metaData) {
      var BreakException = {};
      try {
        Object.keys(metaData).forEach(function (k) {
          if (metaData[k].pwsId===pwsId){
            cnt++;
            annualRep={"awrId":null,"annualReportName":null,"awrMimeType":null};
            if (pwsName)
              pwsName = pwsName.replace(/\w\S*!/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase())); // + " :";
            else
              pwsName = "";
            repName= pwsName+" : Annual Water Quality Report " + metaData[k].year;
            annualRep.annualReportName=repName;
            annualRep.awrId= metaData[k].id;
            annualRep.awrMimeType= metaData[k].mimeType;
            localThis.annualReportList.push(annualRep);
            //localThis.annualReportList.push(JSON.parse(JSON.stringify(annualRep)));
            //throw BreakException;
          }
        });
        if (!repName) {
          this.noAnnualReportMsg = "Sorry, The Annual Water Quality Report is not available for 2016";
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      /!*if (repName) {
        this.annualReportName = repName;
        this.awrId = repId;
        this.awrMimeType = mimeType;
      }*!/
    }*/

    /*this.commonService.getAnnualRepMetaData(pwsId).subscribe(
      metaData => {
        //console.log("AWR metaData", metaData);
        if (metaData) {
          if (pwsName)
            pwsName = pwsName.replace(/\w\S*!/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase())) + " :";
          else
            pwsName = "";
          this.annualReportName = pwsName+" Annual Drinking Water Quality Report 2016";//metaData[0].fileName;
          this.awrId = metaData[0].id;
          this.awrMimeType = metaData[0].mimeType;
        }
      },
      err => console.error("Error in getViolations() call::", err),
      () => {
        if (!this.annualReportName){
          this.noAnnualReportMsg = "Sorry, The Annual Drinking Water Quality Report is not available for 2016";
        }
      }
    );*/
  }

  downloadFile(annualReportName, awrId){
  if(awrId){
  awrId = awrId.replace('{', '%7B').replace('}', '%7D');
  }
   this.commonService.getAnnualRepPDF(awrId).subscribe(
      awrData => {
        if (awrData) {
          var blob = new Blob([awrData], {type: "application/pdf;charset=UTF-8"});
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {  //For IE 11 or Edge browsers
            window.navigator.msSaveOrOpenBlob(blob, annualReportName+'.pdf');
          }
          else {
            try {
              var ua = navigator.userAgent;
              var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
              var webkitUa = !!ua.match(/WebKit/i);
              if (typeof webkitUa !== 'undefined' && iOS && webkitUa && !ua.match(/CriOS/i)){ // true if iOS Safari
                var binary = '';
                var bytes = new Uint8Array( awrData );
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                  binary += String.fromCharCode( bytes[ i ] );
                }
                var base64 = "data:application/pdf;base64,"+window.btoa( binary );
                var uri = encodeURI(base64);
                var anchor = document.createElement('a');
                var fileName=annualReportName + '.pdf';
                document.body.appendChild(anchor);
                anchor.href = uri;
                anchor.download = fileName;
                anchor.click();
                document.body.removeChild(anchor); //open in same tab/window
              }
              else{
                FileSaver.saveAs(blob, annualReportName + '.pdf');   //works for all browsers except IE & iOS Safari
              }
            }catch(err) {
              console.log("Error in saving PDF using FileSaver ::", err);
              var win = open('', 'name'), iframe = document.createElement('iframe'), title = document.createElement('title'),
                  fileUrl = URL.createObjectURL(blob);
                title.appendChild(document.createTextNode(annualReportName + '.pdf'));
                iframe.src = fileUrl;
                iframe.width = '100%';
                iframe.height = '100%';
                iframe.style.border = 'none';
                if (win.document) {
                  win.document.head.appendChild(title);
                  win.document.body.appendChild(iframe);
                  win.document.body.style.margin = '0';
                }
                else{
                  alert('Please disable your pop-up blocker and click the link again.');
                }
            }
          }
        }
      },
      err => console.error("Error in getAnnualRepPDF() call::", err),
      () => { }
    );
  }

  contacts;
  private getDOHContacts(wsysId:number):any{
    //wsysId =716648;  //   REMOVE later..................DELETE after testing  #############################
    var contactAddr;
    this.contacts = null;
    this.commonService.getDOHContacts(wsysId).subscribe(
      contacts => {
        //console.log("contacts", contacts);
        //this.contacts = contacts;
        contactAddr = contacts.addresses[0].address;
        this.contacts =  contactAddr.split("\r\n").join(" <br/>");
      },
      err => console.error("Error in getDOHContacts() call::", err),
      () => {
        //console.log('done with getDOHContacts') //like finally.......

      }
    );
  }



  onRowSelect(event) {
    //console.log("selectedPWS ON SELECT", this.selectedPWS, this.selectedPWS.wsysId);
    //console.log("event", event, event.data);
    //this.violationsCount=0;
    //this.contaminantsCount=0;
    this.pwsPopulation = this.selectedPWS.systemPopulation;
    this.pwsName = this.selectedPWS.pwsName;
    this.pwsCounty = this.selectedPWS.principalCountyServedName;
    //this.getContaminants(this.selectedPWS.wsysId);
    //this.getViolations(this.selectedPWS.wsysId);
    this.getDOHContacts(this.selectedPWS.wsysId);
    //this.getAnnualReport(this.selectedPWS.pwsId, this.selectedPWS.pwsName);
    //this.sharedService.setPwsLatLng("{\"latitude\":\"" + this.selectedPWS.latitude + "\",\"longitude\":\"" + this.selectedPWS.longitude + "\"}");
    this.sharedService.setPwsLatLng("{\"latitude\":\"" + this.selectedPWS.latitude + "\",\"longitude\":\"" + this.selectedPWS.longitude + "\",\"pwsId\":\"" + this.selectedPWS.pwsId + "\"}");
    this.sharedService.setFlowFlag2Lat(this.selectedPWS.latitude);
    this.sharedService.setFlowFlag2Lng(this.selectedPWS.longitude);
  }

  /*onRowUnselect(event) {
    console.log("selectedPWS ON UNSELECT ", this.selectedPWS);
    console.log("event", event, event.data);
  }*/

  private getContaminants(wsysId:number):any{
    //this.files = null;
    this.commonService.getDOHContaminants(wsysId).subscribe(
      pwsContaminants => {
        //console.log("pwsContaminants", pwsContaminants);
        let contaminCnt;
        if (pwsContaminants) {
          for (let contamin of pwsContaminants) {
            //if (contaminCnt!==contamin.violationType){
            //console.log("cont...", contamin)
            //this.contaminantsCount++;
            //violaType=contamin.violationType;
            //}
          }
        }
        //this.files = pwsContaminants;
      },
      err => console.error("Error in getContaminants() call::", err),
      () => {
        //console.log('done with PWS array') //like finally.......

      }
    );
  }
  violations;
  private getViolations(wsysId:number):any{
    this.violations = null;
    this.commonService.getDOHViolations(wsysId).subscribe(
      violation => {
        //console.log("violations", violation);
        let violaType;
        if (violation) {
          for (let viola of violation) {   //console.log(1111,violaType!==viola.violationType, viola)
            if (violaType !== viola.violationType) {
              //this.violationsCount++;
              violaType = viola.violationType;
            }
          }
          this.violations = violation;
        }
      },
      err => console.error("Error in getViolations() call::", err),
      () => {
        //console.log('done with getViolations') //like finally.......

      }
    );
  }
}
